<template>
    <v-container>
      <v-card>
        <v-card-title>Terms of Service</v-card-title>
        <v-card-text>
          <p>Last Updated: 02/2025</p>
  
          <h3 class="text-secondary">1. Acceptance of Terms</h3>
          <p>By accessing and using the Holonet Galactic Encyclopedia website (hereafter referred to as "the Site"), you agree to comply with these Terms of Service ("Terms"). If you do not agree with these Terms, please do not use the Site.</p>
  
          <h3 class="text-secondary">2. Description of Service</h3>
          <p>Holonet Galactic Encyclopedia is an online platform dedicated to Star Wars fans, providing information, analyses, and interactive visualizations about the Star Wars universe. The Site is operated by Yoan Chabot (hereafter referred to as "We" or "Us").</p>
  
          <h3 class="text-secondary">3. Use of the Site</h3>
          <p>Access to the Site is free. However, certain services or features may require registration.</p>
          <p>Users must use the Site responsibly and respectfully. Any illegal, fraudulent, or harmful activities are prohibited.</p>
          <p>Users may submit content (comments, suggestions, etc.). By submitting content, you grant Us a non-exclusive license to use, modify, and display that content.</p>
  
          <h3 class="text-secondary">4. Intellectual Property</h3>
          <p>All content on the Site, including text, images, graphics, logos, and icons, is the property of Us or our licensors.</p>
          <p>You may use the content on the Site for personal, non-commercial purposes. Any other use requires Our prior written consent.</p>
  
          <h3 class="text-secondary">5. Limitation of Liability</h3>
          <p>We strive to provide accurate and up-to-date information, but We do not guarantee the accuracy or completeness of the content.</p>
          <p>The Site may contain links to third-party websites. We are not responsible for the content or practices of these sites.</p>
          <p>We are not liable for any direct, indirect, incidental, consequential, or punitive damages resulting from the use of the Site.</p>
  
          <h3 class="text-secondary">6. Privacy</h3>
          <p>Please refer to Our Privacy Policy to understand how We collect, use, and protect your personal information.</p>
  
          <h3 class="text-secondary">7. Modifications to the Terms</h3>
          <p>We reserve the right to modify these Terms at any time. Changes will take effect upon publication on the Site. It is your responsibility to regularly review the Terms for any updates.</p>
  
          <h3 class="text-secondary">8. Termination</h3>
          <p>We reserve the right to suspend or terminate your access to the Site at any time, without notice, for any violation of these Terms.</p>
  
          <h3 class="text-secondary">9. Governing Law</h3>
          <p>These Terms are governed and interpreted in accordance with the laws of France. Any disputes arising from or related to these Terms will be subject to the exclusive jurisdiction of the courts of France.</p>
  
          <h3 class="text-secondary">10. Contact Information</h3>
          <p>For any questions or concerns regarding these Terms, please contact Us at holonetgalacticencyclopedia@gmail.com.</p>
  
          <h3 class="text-secondary">11. Use of Cookies</h3>
          <p>The Site uses cookies to enhance your browsing experience. By using the Site, you consent to the use of cookies in accordance with Our Cookie Policy.</p>
  
          <h3 class="text-secondary">12. Disclaimer</h3>
          <p>Holonet Galactic Encyclopedia is a fan-made website and is not affiliated with Disney, LucasArts, or any other official Star Wars entities. All Star Wars materials are the property of Disney and LucasArts. We do not claim any rights to these materials.</p>
        </v-card-text>
      </v-card>
    </v-container>
  </template>
  
  <style scoped>
  h3 {
    margin-top: 20px;
  }
  p {
    margin-bottom: 10px;
  }
  </style>
  